import Heading from '@totallymoney/ui/components/Heading'
import Text from '@totallymoney/ui/components/Text'

const ContentUnsecured = () => {
    return (
        <>
            <Heading variant="100" as="h1">
                Guide to unsecured loans
            </Heading>
            <Heading variant="60" as="h2">
                What is an unsecured loan?
            </Heading>
            <Text>
                An unsecured loan is essentially a loan for a one-off essential
                purchase. As these loans are usually for smaller amounts,
                lenders won’t require you to secure the loan against your home,
                however your credit rating will be taken into consideration and
                may determine the amount of money you are able to borrow.
            </Text>
            <Text>
                They are known as unsecured loans to distinguish them from
                secured loans, or{' '}
                <a
                    href="https://www.totallymoney.com/loans/secured/"
                    target="_blank"
                >
                    homeowner loans
                </a>
                , in which the money you borrow is secured against your home.
            </Text>
            <Text>
                Unsecured loans are often known as personal loans as they are a
                good option when you need extra money for small purchases and
                changes in your life, however it can be hard to find the right
                deal for you. Read on to learn about some of the benefits of
                unsecured loans and what other options are available to you.
            </Text>
            <Heading variant="60" as="h2">
                Pros and cons of an unsecured loan
            </Heading>
            <Text>
                An unsecured loan might enable you to borrow more than you can
                with a credit card, and the interest rate is often fixed (but
                not always) making it easier to keep track of your finances.
            </Text>
            <Text>
                An unsecured loan can also be used as a debt consolidation loan
                – used to pay off multiple debts so you can simplify your
                finances by only making one payment each month.
            </Text>
            <Text>
                However unsecured loans can also have higher interest rates than
                you might be offered by secured loans, and some even come with
                early repayment charges, which can be a pain if you are suddenly
                in a position to pay back the money you borrowed. To make sure
                you are finding the cheapest unsecured loan you should decide
                exactly how much money you need (never borrow an excessive
                amount just because it is available to you) and then compare the
                interest rates offered by different types of loan for that
                amount.
            </Text>
            <Text>
                You should also be aware that lenders will look at your credit
                history when deciding on how much you can borrow and at what
                rate. If you have a bad credit rating you might find it harder
                to find a sizeable unsecured loan at a good rate.
            </Text>
            <Heading variant="60" as="h2">
                Alternatives to unsecured loans
            </Heading>
            <Text>
                When considering taking out a loan it is always worth taking a
                minute to look at the other options available and to think about
                what it is you are borrowing the money for. If you need money to
                buy a car then a{' '}
                <a
                    href="https://www.totallymoney.com/loans/car-finance/"
                    target="_blank"
                >
                    car finance loan
                </a>{' '}
                might be a good option.
            </Text>
            <Text>
                Alternatively, if you are looking to borrow a less than £3,000 a{' '}
                <a
                    href="https://www.totallymoney.com/credit-cards/purchase/"
                    target="_blank"
                >
                    credit card
                </a>{' '}
                might actually offer lower interest rates. The longest 0%
                purchase card offer is 27 months, which means if you wish to
                borrow less than £3,000 and are confident that you can repay all
                the money within 27 months then this might be a good option for
                you.{' '}
            </Text>
            <Text>
                Maybe you are hoping to pay off multiple debtors at once to
                simplify your finances? In this case a{' '}
                <a
                    href="https://www.totallymoney.com/loans/debt-consolidation/"
                    target="_blank"
                >
                    debt consolidation loan
                </a>{' '}
                could help you.
            </Text>
            <Heading variant="60" as="h2">
                Things to remember{' '}
            </Heading>
            <Text>
                Having a bad credit rating can limit the amount you are able to
                borrow with an unsecured loan. If you have poor credit history
                there are other ways to borrow money though. Certain{' '}
                <a
                    href="https://www.totallymoney.com/credit-cards/credit-cards-bad-credit/"
                    target="_blank"
                >
                    credit cards
                </a>{' '}
                accept people with bad credit ratings, and you can use our
                comparison tool to see which of these are most likely to accept
                you.
            </Text>
            <Text>
                While you might not be able to secure as much money with a small
                unsecured loan as you might with a secured or homeowner loan
                (because the latter is taken out against your house), it is
                certainly a less risky option. However this doesn’t mean an
                unsecured loan is completely without risk. If you fail to keep
                up with your repayments you could be taken to court and, if you
                receive a County Court Judgement (CCJ) against you, this will
                have a serious impact on your credit rating and make it
                extremely hard to find the cheapest unsecured loans in future.
            </Text>
            <Text>
                As with taking out any loan or credit card, you need to be sure
                that you have budgeted so you can make the repayments each
                month. You should also be aware that the longer it takes to pay
                back the loan in full, the more interest you will be paying,
                making the loan ever more expensive.
            </Text>
        </>
    )
}

export default ContentUnsecured
